import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=b0aa4026&scoped=true"
import script from "./Values.vue?vue&type=script&lang=js"
export * from "./Values.vue?vue&type=script&lang=js"
import style0 from "./Values.vue?vue&type=style&index=0&id=b0aa4026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aa4026",
  null
  
)

export default component.exports